module.exports = __webpack_public_path__ + "static/media/sketches.449202a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/sketches.jpg
// module id = 423
// module chunks = 0